import { ACTION } from '@approot/global-websocket';

export enum RunningState {
  Running = 'RUNNING',
  Idle = 'IDLE'
}

type Payload = {
  item: any;
  nItems: number;
  error: boolean;
  warning: boolean;
  message: string;
};

export type Row = Payload & { uuid: string; info: string };

export type WSRow = {
  action: ACTION;
  uuid: string;
  payload: Payload;
};

export type EntitiesState = Partial<{
  entities: string[];
  realEntities: string[];
  selectedEntity: string;
}>;

export function sorter(a: string, b: string) {
  return a.localeCompare(b, 'en', { sensitivity: 'accent' });
}
